import React, { useState, useEffect } from 'react';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-[#F5F0EB] shadow-sm' : 'bg-[#1B4D3E]'
    }`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex justify-between items-center">
        <a 
          href="#hero" 
          onClick={(e) => scrollToSection(e, 'hero')}
          className={`text-xl md:text-2xl font-bold transition-colors ${
            scrolled ? 'text-[#1B4D3E]' : 'text-[#F5F0EB]'
          }`}
          style={{fontFamily: 'Space Grotesk, sans-serif'}}
        >
          Super Boring Company
        </a>
        
        <div className="hidden lg:flex items-center gap-8">
          {[
            { label: 'Our Brands', id: 'our-brands' },
            { label: 'Our Thesis', id: 'our-thesis' },
            { label: 'What We Buy', id: 'what-we-buy' },
            { label: 'Our Process', id: 'our-process' },
            { label: 'FAQs', id: 'faqs' }
          ].map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => scrollToSection(e, item.id)}
              className={`text-sm font-medium transition-colors hover:opacity-70 ${
                scrolled ? 'text-[#1B4D3E]' : 'text-[#F5F0EB]'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => scrollToSection(e, 'contact')}
            className={`px-4 py-2 text-sm font-medium rounded transition-all ${
              scrolled 
                ? 'bg-[#1B4D3E] text-[#F5F0EB] hover:opacity-90' 
                : 'border-2 border-[#F5F0EB] text-[#F5F0EB] hover:bg-[#F5F0EB] hover:text-[#1B4D3E]'
            }`}
          >
            Get in Touch
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;